import axios from "axios";

// Actions
export const FETCH_SECRET_QUESTIONS_REQUEST =
  "secret-questions/FETCH_SECRET_QUESTIONS_REQUEST";
export const FETCH_SECRET_QUESTIONS_SUCCESS =
  "secret-questions/FETCH_SECRET_QUESTIONS_SUCCESS";
export const FETCH_SECRET_QUESTIONS_FAILURE =
  "secret-questions/FETCH_SECRET_QUESTIONS_FAILURE";

// Reducer
export const initialState = {
  loading: true,
  error: null
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_SECRET_QUESTIONS_REQUEST:
      return { ...state, error: null, loading: true };
    case FETCH_SECRET_QUESTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        ...action.payload
      };
    case FETCH_SECRET_QUESTIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    default:
      return state;
  }
}

// Action Creators
export const fetchSecretQuestionsRequest = () => ({
  type: FETCH_SECRET_QUESTIONS_REQUEST
});

export const fetchSecretQuestionsSucess = data => ({
  type: FETCH_SECRET_QUESTIONS_SUCCESS,
  payload: data
});

export const fetchSecretQuestionsFailure = error => ({
  type: FETCH_SECRET_QUESTIONS_FAILURE,
  payload: error
});

export const fetchSecretQuestions = (
  baseUrl = "/public/api"
) => async dispatch => {
  dispatch(fetchSecretQuestionsRequest());
  try {
    const response = await axios.get(`${baseUrl}/secretQuestions`);
    dispatch(fetchSecretQuestionsSucess(response.data));
  } catch (error) {
    dispatch(fetchSecretQuestionsFailure(error));
  }
};

/// Selectors
export const getSecretQuestions = state =>
  state.secretQuestions.secretQuestions || [];
export const getSecretQuestionsError = state => state.secretQuestions.error;

export const getSecretQuestionsLoading = state => state.secretQuestions.loading;
